export default __webpack_public_path__ + "static/media/downArrow.af263d89.svg";